import { Pagination } from "antd";

/**
 * Reusable pagination bar for server-side (API) paginated tables.
 *
 * Props
 *  - current        : current page number (1-based)
 *  - pageSize       : rows per page
 *  - total          : totalRecords returned by the API
 *  - onChange(page, size) : called when page or page size changes
 *  - loading        : disables the controls while a request is in flight
 *  - pageSizeOptions: list of page sizes
 *  - align          : "left" | "center" | "right" (default "right")
 */
const ServerPagination = ({
  current = 1,
  pageSize = 10,
  total = 0,
  onChange,
  loading = false,
  pageSizeOptions = ["10", "20", "50", "100"],
  align = "right",
}) => {
  if (!total) return null;

  const justify =
    align === "left"
      ? "flex-start"
      : align === "center"
        ? "center"
        : "flex-end";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: justify,
        alignItems: "center",
        flexWrap: "wrap",
        gap: 8,
        padding: "12px 4px",
      }}
    >
      <Pagination
        current={current}
        pageSize={pageSize}
        total={total}
        disabled={loading}
        showSizeChanger
        showQuickJumper
        pageSizeOptions={pageSizeOptions}
        responsive
        size="small"
        showTotal={(t, range) => `${range[0]}–${range[1]} of ${t} records`}
        onChange={(page, size) => onChange?.(page, size)}
      />
    </div>
  );
};

export default ServerPagination;
